window.onload = () => {
  const iframe = document.querySelector('.js-iframe');
  if (!iframe) {
    return;
  }
  const subnavs = document.querySelectorAll('.js-sub-nav');
  for (let i = 0; i < subnavs.length; i += 1) {
    const subnav = subnavs[i];
    subnav.onclick = (e) => {
      e.preventDefault();
      if (e.target.attributes['data-url'] != null) {
        iframe.src = e.target.attributes['data-url'].value;
      }
    };
  }
};



// WEBPACK FOOTER //
// ./js/components/init-iframe.js